// Compact relative time for the chat list: "just now", "50s ago", "1m ago",
// "1h ago", up to "30d ago", then an absolute date once older than ~1 month.
export function timeAgo(ts: number): string {
  if (!ts) return ''
  const diff = Date.now() - ts
  if (diff < 0) return 'just now'

  const sec = Math.floor(diff / 1000)
  if (sec < 5) return 'just now'
  if (sec < 60) return `${sec}s ago`

  const min = Math.floor(sec / 60)
  if (min < 60) return `${min}m ago`

  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr}h ago`

  const day = Math.floor(hr / 24)
  if (day < 30) return `${day}d ago`

  // Older than ~1 month → show a short date (add the year only if it differs).
  const date = new Date(ts)
  const now = new Date()
  const opts: Intl.DateTimeFormatOptions =
    date.getFullYear() === now.getFullYear()
      ? { day: 'numeric', month: 'short' }
      : { day: 'numeric', month: 'short', year: 'numeric' }
  return date.toLocaleDateString(undefined, opts)
}
